// import React from 'react'
// import { ResponsiveBar } from '@nivo/bar'
// import { useSelector } from "react-redux";



// const lineGraphSettings = {
//     theme: {
//         fontSize: '11px',
//         tooltip: {
//             position: "absolute",
//             container: {
//                 background: 'red',
//             }
//         }
//     },
// };

// export default function BarChartcom(props) {
//     const { DateFilters } = props;
//     // const barChartData = [
//     //     {
//     //         "label": "A&E",
//     //         "value": 0.18,
//     //         "altValue": 9429.28594028965
//     //     },
//     //     {
//     //         "label": "AMC",
//     //         "value": 0.120,
//     //         "altValue": 6254.484754679497
//     //     },
//     //     {
//     //         "label": "BBCA",
//     //         "value": 0.055,
//     //         "altValue": 2857.249584943114
//     //     },
//     // ]
//     const state = useSelector((state) => state);
//     const graphData =
//         state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData || [];




//     const barChartData = graphData.map((value, index) => {
//         const key =
//             DateFilters === 'ThisWeek'
//                 ? `Day ${index + 1}`
//                 : DateFilters === 'ThisMonth'
//                     ? `Week ${index + 1}`  // Map index to month name
//                     : monthNames[index % 12];

//         return {
//             label: key, // Common key for the X-Axis
//             value: value, // Data value for the Y-Axis
//             altValue: ""
//             //   altValue: value * 1000, // Example transformation for altValue (can be customized based on your need)
//         };
//     });


//     // const data = barChartData.map((item) => ({
//     //     ...item, id: item.label, value: item.value
//     //     // ...item, id: item.label, value: item.value * 100
//     // }))

//     const data = [
//   { category: 'A', value: 55 },
//   { category: 'B', value: 65 },
//   { category: 'C', value: 80 },
//   { category: 'D', value: 40 },
//   // Add more data points here
// ];


//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//     const Percentagelist = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
//     const minValue = Math.min(...data.map(d => d.value));
//     const maxValue = Math.max(...data.map(d => d.value));

//     const dynamicTicks = Percentagelist.filter(v => v >= minValue && v <= maxValue);








//     // const { value: maxValue } = data.reduce((prev, current) =>
//     //     (prev.value > current.value) ? prev : current)

//     // const yMax = Math.round(maxValue + (maxValue % 4))
//     // console.log(yMax, "sadopaisd yMax");
//     const formatPercentage = (v) => `${v} %`;

//     return (
//         <ResponsiveBar
//             data={data}
//             labelTextColor={'white'}
//             margin={{ top: 50, bottom: 50, left: 100, right: 40 }}
//             padding={0.4}
//             tooltip={(toolTip) => (<span style={{ fontSize: '12px', color: 'white', background: "red" }}>
//                 {toolTip.value}</span>)}
//             labelFormat={d => <tspan fontSize={'11px'} y={-10}>{(d).toFixed(1)}</tspan>}
//             label={({ value }) => (
//                 <tspan fontSize="11px" y={-10} textAnchor="middle">{value}</tspan>
//             )}

//             // colors={"#005587"}
//             colors={"#F26639"}
//             theme={lineGraphSettings.theme}
//             borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
//             borderRadius={"12px 12px 0px 0px"}
//             axisTop={null}
//             axisRight={null}
//             // minValue={0}
//             // maxValue={yMax}
//             gridYValues={11}
//             axisBottom={{
//                 tickSize: 0,
//                 tickPadding: 5,
//                 tickRotation: 0,
//                 legendPosition: 'middle',
//                 legendOffset: 32
//             }}
//             axisLeft={{
//                 // tickValues: 5,
//                 // tickValues: 10, // Use Percentagelist for tick values
//                 tickSize: 0,
//                 tickPadding: 10,
//                 tickValues: dynamicTicks, // Use dynamic ticks based on data

//                 // tickValues: Percentagelist,  // Use Percentagelist for tick values (0%, 10%, 20%, ...)
//                 // format: (v) => `${v} %`,  // Format ticks as percentages

//                 // format: (Percentagelist) => `${v}`,
//                 // format: v => `${v} %`,
//                 // format: (v) => `${(v * 100).toFixed(0)} %`,  // Convert to percentage format
//                 // format: formatPercentage, // Use the custom formatting function to add '%' to ticks
//                 format: (v) => `${v} %`, // Format ticks as percentages (0%, 10%, 20%, ...)

//                 legendPosition: 'middle',
//                 legendOffset: -50
//             }}


//             animate={true}
//             motionStiffness={90}
//             motionDamping={15}
//         />
//     )
// }


import React from 'react';
import { BarChart, XAxis, YAxis, CartesianGrid, Tooltip, Bar, ResponsiveContainer } from 'recharts';
import { useSelector } from "react-redux";


const SimpleBarChart = (props) => {
    const { DateFilters } = props;
    // Data for the bar chart

    const state = useSelector((state) => state);
    const graphData =
        state.Ticketingrecord_dashboard?.ticketDashboardData?.PercentageGraphData || []
    //   state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData || [];

    const countofpercentage =
        state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData || []

        const mergedData = graphData.map((data, index) => ({
            x: index,  // Use the index as the x value
            y: countofpercentage[index] || 0,   // Map PercentageGraphData to y
            percentage: data   // Add the corresponding value from GraphData to the response
        }));
        
        // Optionally, if the arrays have different lengths, you can handle that case as well
        const finalMergedData = mergedData.map((item, index) => ({
            ...item,
            // If you want to merge additional data from PercentageGraphData, you can access them here
            additionalData: graphData[index]?.someProperty || null,  // Example of adding more data from PercentageGraphData if necessary
        }));
        


    //   const barChartData = graphData.map((value, index) => {
    //       const key =
    //           DateFilters === 'ThisWeek'
    //               ? `Day ${index + 1}`
    //               : DateFilters === 'ThisMonth'
    //                   ? `Week ${index + 1}`  // Map index to month name
    //                   : monthNames[index % 12];

    //       return {
    //           label: key, // Common key for the X-Axis
    //           value: value, // Data value for the Y-Axis
    //           altValue: ""
    //           //   altValue: value * 1000, // Example transformation for altValue (can be customized based on your need)
    //       };
    //   });

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const Week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const labeldata = countofpercentage.map((value, index) => {
        const key =
            DateFilters === 'ThisWeek'
                ? `Day ${index + 1}`
                : DateFilters === 'ThisMonth'
                    ? `Week ${index + 1}`
                    : monthNames[index % 12];

        return {
            x: key,  // Use index for the x value (matching the format you requested)
            y: value,  // Map the data value to the y value
        };
    });
    console.log(finalMergedData ,"asduaspdi finalMergedData",labeldata); 


    const labeldatarespo = labeldata.map((item) => ({
        x: item.x,  // Copy x value (same as in data)
        y: item.y,  // Copy y value (same as in data)
    }));



    const data = graphData.map((value, index) => {
        const key =
            DateFilters === 'ThisWeek'
                // ? ` ${index + 1}`
                ? Week[index % 7]
                : DateFilters === 'ThisMonth'
                    ? `Week ${index + 1}`
                    : monthNames[index % 12];

        return {
            x: key,  // Use index for the x value (matching the format you requested)
            y: value,  // Map the data value to the y value
        };
    });


    // console.log(data, "asdsad DateFilters", state.StateManagementOverallCall.DefualtDatefilyer);


    return (


        <>
            <div className='card OpeningChartDetails'>
                <div className='card-body'>
                    <p><span>X axis - </span> <span>{state.StateManagementOverallCall.DefualtDatefilyer == "ThisWeek" ?
                        "Day" : state.StateManagementOverallCall.DefualtDatefilyer == "ThisMonth" ?
                            "Week" : "Month"}
                    </span></p>
                    <p><span>Y axis - </span> <span>Percentage</span></p>

                </div>
            </div>



            <ResponsiveContainer width="100%" height={358}>
                <BarChart data={data}>
                    {/* <CartesianGrid strokeDasharray="3 3" /> */}

                    <XAxis dataKey="x" type="category" domain={['dataMin', 'dataMax']} />

                    <YAxis type="number" domain={[0, 100]}
                    //   tickFormatter={(value) => `${value}%`} 

                    />

                    {/* Tooltip */}
                    {/* <Tooltip /> */}

                    {/* Bars */}
                    <Bar dataKey="y" fill="#F26639"
                        radius={[10, 10, 0, 0]} // Top-left and top-right corners have rounded borders

                        // label={({ x, y, index }) => {
                        //     const labelValue = finalMergedData[index].y;  // Get y value from labeldata using index
                        //     const Percentagevalus = finalMergedData[index].percentage;  // Get y value from labeldata using index

                        //     const barHeight = 100; // Replace with your actual bar height logic if available
                        //     const adjustedY = Percentagevalus / 100 ; // Center vertically on the bar
                        //     console.log(Percentagevalus ,"Percentagevalus",adjustedY);
                            
                        //     return (


                        //         <text
                        //             x={
                        //                 state.StateManagementOverallCall.DefualtDatefilyer === "ThisWeek" ?
                        //                     x + 40 : state.StateManagementOverallCall.DefualtDatefilyer === 'ThisMonth' ?
                        //                         x + 60 :
                        //                         x + 26

                        //             }
                        //             y={adjustedY}

                        //             // y ={
                        //             //     state.StateManagementOverallCall.DefualtDatefilyer === "ThisWeek" ?
                        //             //     y + 30 : state.StateManagementOverallCall.DefualtDatefilyer === 'ThisMonth' ?
                        //             //         y + 60 :
                        //             //         y + 90
                        //             // }
                        //             // y={labelValue == 1 ? y - (-10) : y - (-35)}
                        //             fill="#fff"
                        //             fontSize={19}
                        //             textAnchor="middle"
                        //             dominantBaseline="middle"  
                        //             className='Textbarslisted'
                        //             pointerEvents="none" // Disable pointer events on the label

                        //         >
                        //             {`${labelValue == 0 ? "" : labelValue}`}  {/* Display value as percentage */}
                        //         </text>

                        //     );
                        // }}

                        label={({ x, y, width, height, index }) => {
                            const labelValue = finalMergedData[index].y;  // Get y value from label data using index
                            const percentageValue = finalMergedData[index].percentage;  // Get percentage value
                    
                            // Calculate the adjusted Y position dynamically based on the bar height
                            const adjustedY = y + height / 2;  // Adjust label vertically to be centered on the bar
                            
                            // Ensure the label is only shown for non-zero values
                            return (
                              <text
                                x={x + width / 2}  // Horizontally center the label within the bar
                                y={adjustedY}
                                fill="#fff"
                                fontSize={19}
                                textAnchor="middle"
                                dominantBaseline="middle"
                                className="Textbarslisted"
                                pointerEvents="none"  // Disable pointer events on the label
                              >
                                {labelValue === 0 ? "" : labelValue }  
                              </text>
                            );
                          }}
                    




                    />
                </BarChart>
            </ResponsiveContainer>

        </>


    );
};

export default SimpleBarChart;

